export default __webpack_public_path__ + "static/derrick1-82efb5d7867a123a9e6e213829d3658c.jpg";